import React from 'react';
import { Link } from 'react-router-dom';

const products = [
  {
    title: 'WhatsApp CRM',
    text: 'Manage leads, customer chats, follow-ups, and team communication from a simple CRM workflow built around WhatsApp business conversations.',
    icon: 'fa-whatsapp',
    to: '/products/whatsapp-crm/',
    points: ['Lead handling', 'Follow-up workflow', 'Team visibility'],
  },
  {
    title: 'School Management',
    text: 'Run student records, fee tracking, admissions, staff access, and daily school operations through a structured digital system.',
    icon: 'fa-graduation-cap',
    to: '/products/school-management/',
    points: ['Student records', 'Fee management', 'Role-based access'],
  },
  {
    title: 'Medical Wholesale & Retail App',
    text: 'Support medicine ordering, catalog handling, wholesale-retail workflow, and business operations with a practical app direction.',
    icon: 'fa-medkit',
    to: '/products/medical-wholesale-retail-app/',
    points: ['Medicine catalog', 'Order workflow', 'Retail and wholesale'],
  },
];

const HomeProductsSection = () => (
  <section className="home-products-section">
    <div className="auto-container">
      <div className="section-heading text-center">
        <h3>SwiftMaze Products</h3>
        <span className="animate-border"></span>
      </div>

      <div className="home-products-intro">
        Practical software products for communication, education operations, and medical business workflows.
      </div>

      <div className="row clearfix">
        {products.map((product) => (
          <div className="col-lg-4 col-md-6 col-sm-12" key={product.title}>
            <Link className="home-product-card" to={product.to}>
              <span className="home-product-icon">
                <i className={`fa ${product.icon}`} aria-hidden="true"></i>
              </span>
              <h4>{product.title}</h4>
              <p>{product.text}</p>
              <ul>
                {product.points.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
              <span className="home-product-link">View Product</span>
            </Link>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HomeProductsSection;
